import { useState, useCallback } from 'react';

export interface ImageItem {
    localIdentifier: string;
    uri: string;
    s3Url?: string;
    uploadState: 'waiting' | 'uploaded';
}

export const useImageUploader = () => {
    const [images, setImages] = useState<ImageItem[]>([]);

    const addImages = useCallback((files: File[]) => {
        const newImages: ImageItem[] = files.map((file, index) => ({
            localIdentifier: `new-${Date.now()}-${index}`,
            uri: URL.createObjectURL(file),
            uploadState: 'waiting' as const
        }));
        
        setImages(prev => [...prev, ...newImages]);
        
        // TODO: Implement S3 upload logic here
        // For now, simulate upload completion after a delay
        newImages.forEach((image, index) => {
            setTimeout(() => {
                setImages(prev => prev.map(img => 
                    img.localIdentifier === image.localIdentifier 
                        ? { ...img, uploadState: 'uploaded' as const, s3Url: `https://s3.amazonaws.com/fake-bucket/${image.localIdentifier}` }
                        : img
                ));
            }, (index + 1) * 1000);
        });
    }, []);

    const removeImage = useCallback((localIdentifier: string) => {
        setImages(prev => {
            const imageToRemove = prev.find(img => img.localIdentifier === localIdentifier);
            if (imageToRemove?.uri.startsWith('blob:')) {
                URL.revokeObjectURL(imageToRemove.uri);
            }
            return prev.filter(img => img.localIdentifier !== localIdentifier);
        });
    }, []);

    return {
        images,
        addImages,
        removeImage,
        setImages
    };
};